import React, {useState, useEffect, SyntheticEvent} from 'react';
import {useIntl} from 'react-intl';

import {RadioButton, RadioGroup} from '@homeaway/react-form-components';
import {
    FILTER_OPTION_NIGHTLY_PRICE,
    FILTER_OPTION_TOTAL_PRICE,
} from '../../utils/constants';
import './PriceFilterByPriceType.less';

type Props = {
    isFilterByTotalPriceEnabled: boolean;
    isFilterByTotalPriceSelected: boolean;
    onChange: (filterByTotalPrice: boolean) => void;
};

const PriceFilterByPriceType = ({
    isFilterByTotalPriceEnabled,
    isFilterByTotalPriceSelected,
    onChange,
}: Props) => {
    // if "filter by total price" is selected, but radio button is not enabled
    // reset "filter by total price" to be unselected
    useEffect(() => {
        if (isFilterByTotalPriceSelected && !isFilterByTotalPriceEnabled) {
            onChange(false);
        }
    });

    const intl = useIntl();
    const {formatMessage} = intl;
    const handleOnChange = (event: SyntheticEvent<HTMLInputElement>) => {
        onChange(event.currentTarget.value === FILTER_OPTION_TOTAL_PRICE);
    };

    return (
        <div className={'PriceFilterByPriceType'}>
            <div className={'PriceFilterByPriceType__title small'}>
                {formatMessage({
                    id: 'propertyFilterPrice',
                    defaultMessage: 'Filter by:',
                    description: 'filter by nightly or total price',
                })}
            </div>
            <RadioButton
                label={formatMessage({
                    id: 'propertyNightlyPrice',
                    defaultMessage: 'Nightly price',
                    description: 'filter by nightly price',
                })}
                value={FILTER_OPTION_NIGHTLY_PRICE}
                checked={!isFilterByTotalPriceSelected}
                onChange={handleOnChange}
                size={'sm'}
                className="small"
            />

            <RadioButton
                label={formatMessage({
                    id: 'propertyTotalPrice',
                    defaultMessage: 'Total price',
                    description: 'filter by total price',
                })}
                value={FILTER_OPTION_TOTAL_PRICE}
                checked={isFilterByTotalPriceSelected}
                onChange={handleOnChange}
                size={'sm'}
                className="small"
                disabled={!isFilterByTotalPriceEnabled}
            />
        </div>
    );
};

export default PriceFilterByPriceType;
